export const getCoinNews = async (abbr: string, name: string) => {
	const query = abbr ? `${abbr} ${name}` : `${name}`;

	try {
		const res = await fetch(`/api/news/coin-news/?query=${query}`);
		return res.json();
	} catch (error) {
		console.error(error);
	}
};
